exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.avatar-uploader[data-v-04c71dd0] .el-upload--picture-card {\n\t\twidth: 100px;\n\t\theight: 100px;\n        line-height: 100px;\n}\n.avatar-uploader-icon[data-v-04c71dd0] {\n\t\tfont-size: 28px;\n\t\tcolor: #8c939d;\n\t\twidth: 100px;\n\t\theight: 100px;\n\t\tline-height: 100px;\n\t\ttext-align: center;\n}\n.avatar[data-v-04c71dd0] {\n\t\theight: 100px;\n\t\tdisplay: block;\n}\n\n", ""]);

// exports
